import Amplify, { Auth, Hub } from 'aws-amplify';
import { HubCallback } from '@aws-amplify/core';

import { setCognitoSession, removeCognitoSession } from 'src/utils/session';
import * as routes from 'src/constants/routeUrl';
import config from 'src/config';

Amplify.configure({
  aws_project_region: config.cognitoProjectRegion,
  aws_cognito_region: config.cognitoRegion,
  aws_user_pools_id: config.cognitoPoolId,
  aws_user_pools_web_client_id: config.cognitoClientId,
  oauth: {
    domain: config.cognitoDomain,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: `${window.location.origin}/`,
    redirectSignOut: `${window.location.origin}/logout`,
    responseType: 'code',
  },
  Auth: {
    identityPoolId: config.cognitoIdentityPoolId,
  },
});

const eventListener =
  (push?: (url: string) => void): HubCallback =>
  ({ payload: { event, data } }) => {
    switch (event) {
      case 'signIn':
        setCognitoSession(data);
        push?.(routes.HOME);
        break;
      case 'signOut':
        removeCognitoSession();
        push?.(routes.LOGIN);
        break;
    }
  };
const HubListener = (push?: (url: string) => void) => {
  Hub.listen('auth', eventListener(push));
};

const RemoveHubListener = () => {
  Hub.remove('auth', eventListener());
};

export { Auth, HubListener, RemoveHubListener };
